import React from "react";
// Common Components
import { CheckBox, Button, Modal } from "src/Components";
import TableTemplate, {
  IFilterTableCols,
} from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
// Requests
import { getCalculationTable } from "src/Requests/automaticMarketMaking";
// Types
import { Report } from "src/Interfaces/TableInterfaces";

interface IVisibleHeaders {
  all: boolean;
  mediator: boolean;
}

const Calculation: React.FC = () => {
  const [visibleHeaders, setVisibleHeaders] = React.useState(
    {} as IVisibleHeaders
  );

  const changeHandler = (name: string, value: any) => {
    setVisibleHeaders({ ...visibleHeaders, [name]: value } as IVisibleHeaders);
  };

  const getFilterCols = (): IFilterTableCols => {
    const result: IFilterTableCols = {
      show: true,
      tableName: "optionDomainPairPositionTable",
      allowedPositions: [],
    };
    if (visibleHeaders.all) result.allowedPositions.push("DefaultHidden");
    if (visibleHeaders.mediator) result.allowedPositions.push("Mediator");
    return result;
  };
  return (
    <div className="flex flex-col justify-start items-start gap-2 relative pt-5 mx-auto p-8 w-full">
      <div className="flex justify-start items-center w-full">
        <div className="flex flex-row justify-start items-center gap-5">
          <div className="bg-sky-200 rounded py-1 px-2">
            <CheckBox
              checked={visibleHeaders.all}
              label="جزئیات"
              name="all"
              onChange={changeHandler}
            />
          </div>
          <div className="bg-red-200 rounded py-1 px-2">
            <CheckBox
              checked={visibleHeaders.mediator}
              label="محاسبات"
              name="mediator"
              onChange={changeHandler}
            />
          </div>
        </div>
      </div>
      <TableTemplate
        TableUI={({ reports, onAction }) => (
          <CommonTableUI
            reports={reports}
            onAction={onAction}
            filterCols={getFilterCols()}
            tableBoxClassName="!max-h-[800px]"
            withSelect
          />
        )}
        refreshTableTime={30000}
        getDataTable={getCalculationTable}
      />
    </div>
  );
};

export default Calculation;
